/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserLifecycleState } from './userLifecycleState';

/**
 * Lifecycle state for all users. Note that 'stale' and 'finished' primarily apply to students.
 */
export type UserUpdateState = UserLifecycleState | null;
